import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import BgImg from "../../images/home-update/sub-bg-image.webp";
import { Link } from "gatsby";

function Subbanner({ handleShow }) {
  return (
    <section
      className="tekrevol__sub overflow-x-hidden"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container>
        <Row className="justify-content-center">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="mt-auto mb-auto"
          >
            <div className="banner-wrap text-center">
              <div
                className="example example-bottom center text-center"
                data-text="Discuss Project"
              >
                <h2>Gain Digital Edge, Accelerate Growth</h2>
              </div>
              <p>
                Let's discuss how our end-to-end solutions can drive growth for
                your industry. Book a <br className="d-md-block d-none" />
                free consultation now.
              </p>
              <div className="btn-wrap text-center">
                <span className="btn-pri" onClick={handleShow}>
                  Start with a Free Call
                </span>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Subbanner;
